export default __webpack_public_path__ + "static/media/ic_wbtc(w)_40.8330ef8d.svg";